import login from './login';

export default {
  language: 'pl-PL',
  country: 'pl',
  name: 'Polski',
  embeddedLocale: login,
};
